import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>There are many situations where it isn’t necessary to
                                                re-invent the wheel but rather look at what is being done or
                                                has been done already to learn from experience. This tool is
                                                about <span className="green"><strong>how to improve processes</strong></span> and
                                                will help you to identify processes that could benefit from
                                                improvements as well as the ways in which these improvements
                                                can be developed.</p>
                                            <div className="circle_title"><span className="heading"><span
                                                className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">CULTURE OF CONTINUOUS IMPROVEMENT</span></span>
                                            </div>
                                            <p>It’s easy to complain when something’s not working – it lets
                                                us vent our annoyance. In a corporate environment, however,
                                                serious consideration should be given to all the possible
                                                impacts of change.</p>
                                            <p>All of a sudden, whatever it was you used to complain about
                                                is gone, but now you need training to deal with a new system
                                                – and change can be uncomfortable! The impact of change can
                                                be far reaching and complex – here’s how to help deal with
                                                change or avoid it altogether!</p>
                                            <p>Change within an organisation must be properly managed. It’s
                                                easy enough to correct a single process but it’s more
                                                daunting if it involves introducing complete new systems or
                                                technology – and getting people ‘on side’. For more
                                                information on gaining buy-in refer to the tool ‘How to gain
                                                buy-in and commitment’.</p>
                                            <p>A culture of continuous change and improvement prevents an
                                                organisation from stagnating and helps it remain
                                                competitive. However, it’s essential to recognise the
                                                potential problems associated with change itself.</p>
                                            <p>Change, when introduced effectively, can be a seamless and
                                                easy process. However, it takes careful planning, as you’re
                                                about to find out…</p>
                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">‘IF IT AIN’T BROKE, DON’T FIX IT’</span>
                                            </div>
                                            <p>Processes – series of actions to achieve an end result – are
                                                part of our day-to-day existence, whether we’re aware of
                                                them or not. Many happen without due thought even about
                                                their correctness or usefulness. We notice them only when
                                                things don’t work the way we expect.</p>
                                            <div className="border_subtitle">So why do we need to improve
                                                processes?
                                            </div>
                                            <p>Some businesses are more process-driven than others. Many
                                                processes work for years without needing to be changed;
                                                others need constant tinkering because of changes in
                                                technology, legislation or market conditions.</p>
                                            <div className="uiheading space-sep">
                                                <p>Think about processes at work. Think about one you hate
                                                    because it takes too long, is difficult or fiddly.</p>
                                            </div>
                                            <div className="lightgreencontentbg uiheadingnew pad-seperate">
                                                <p><strong>Why is this so complicated?</strong></p></div>
                                            <div className="lightgreencontentbg uiheadingnew pad-seperate">
                                                <p><strong>Who thought this system was a good idea?</strong>
                                                </p></div>
                                            <div className="lightgreencontentbg uiheadingnew pad-seperate">
                                                <p><strong>Why can’t we just get this done?</strong></p>
                                            </div>

                                            <p style={{paddingTop: '20px'}}>It’s often easy to think that
                                                something could be done differently, or that it’s a complete
                                                waste of time, but try to imagine life without some of those
                                                processes you complain about.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}